module.exports = __webpack_public_path__ + "img/9788998046538.1cc5e77c.jpg";